module.exports = __webpack_public_path__ + "img/242cb94.jpg";